<template>
  <A2PRegistrationWizard
    :target-site-i-d="targetSiteID"
    :target-site-name="targetSiteName"
    :target-site-country="targetSiteCountry"
  />
</template>

<script>
import A2PRegistrationWizard from './A2PRegistrationWizard.vue';
export default {
  name: 'A2PRegistrationPage',
  components: { A2PRegistrationWizard },
  computed: {
    targetSiteID() {
      return this.$route.query.siteID || null;
    },
    targetSiteName() {
      return this.$route.query.siteName || null;
    },
    /**
     * Only the Super Admin modal used to pass this, so reaching the wizard by
     * URL always warned "Country not set in database" and silently defaulted to
     * US — harmless for a US practice, wrong-by-default for a Canadian one.
     * Accepts the same forms `normalizeCountryCode` handles in SuperAdmin.vue.
     */
    targetSiteCountry() {
      const raw = this.$route.query.country || this.$route.query.siteCountry;
      if (!raw) return null;
      const n = String(raw).trim().toUpperCase();
      if (['CA', 'CAN', 'CANADA'].includes(n)) return 'CA';
      if (['US', 'USA', 'UNITED STATES', 'UNITED STATES OF AMERICA'].includes(n)) return 'US';
      return null;
    }
  }
};
</script>

<style scoped>
</style>
